module.exports = __webpack_public_path__ + "static/media/15UN-Habitat11.87a44de0.jpg";